/**
 * @fileoverview Variáveis do template no "Enviar Mensagem" ligado ao "Status da
 * OS": a origem de cada {{n}} (dados do aviso do Care, do contato, da empresa
 * ou texto fixo) e a prévia. Reaproveita o seletor da triagem e das abordagens
 * (TemplateFields), com as origens do aviso da OS. Guarda no nó
 * `templateVariables` ({ "1": "order.customerFirstName", ... }).
 */

import React from "react";

import { TemplateFields } from "../../components/TriageManager/metaTemplates";
import { extractTemplateVars } from "../../../../utils/templateVars";
import { templateBodyText, templateProblemKey } from "../../../../utils/metaTemplateRules";

// Origens que o servidor sabe preencher (ServiceOrderFlowServices/rules/variableRules).
export const ORDER_TEMPLATE_SOURCES = [
  { value: "order.customerFirstName", label: "Primeiro nome do cliente (Care)", example: "Maria" },
  { value: "order.customerName", label: "Nome do cliente (Care)", example: "Maria Souza" },
  { value: "order.number", label: "Número da OS", example: "1672326" },
  { value: "order.ticketNumber", label: "Número do chamado", example: "4176896588" },
  { value: "order.status", label: "Status da OS", example: "Ag. Aprov. Orçamento" },
  { value: "order.amount", label: "Valor da OS", example: "R$ 350,00" },
  { value: "contact.firstName", label: "Primeiro nome do contato", example: "Maria" },
  { value: "contact.name", label: "Nome do contato", example: "Maria Souza" },
  { value: "company.name", label: "Nome da empresa", example: "Assistência" },
  { value: "fixed", label: "Texto fixo" },
];

// Por que o template não sai sozinho para cada OS (o texto da triagem fala dela).
const PROBLEM_TEXT = {
  authTemplate: "é de autenticação",
  namedVariable: "usa variável com nome",
  mediaHeader: "tem mídia no cabeçalho",
  headerVariable: "tem variável no título",
  codeButton: "tem botão de código ou de fluxo",
  urlVariable: "tem botão de link com variável",
};

/** Por que o template não serve para o envio por status de OS (null: serve). */
export const orderTemplateProblem = (tpl) => {
  const key = templateProblemKey(tpl);
  return key ? PROBLEM_TEXT[key] || key : null;
};

/** Variáveis de um template recém-escolhido: {{1}} já vem com o primeiro nome do cliente. */
export const initialOrderVariables = (tpl) => {
  const variables = {};
  extractTemplateVars(templateBodyText(tpl)).forEach((n) => {
    variables[n] = n === "1" ? "order.customerFirstName" : "";
  });
  return variables;
};

const OrderTemplateVariables = ({ nodeData, templates, loading, updateNodeData, isDark }) => {
  const selected = nodeData.selectedTemplate || {};
  const chosen =
    (templates || []).find((t) => t.name === nodeData.templateName && t.language === selected.language) || null;
  // Mesmo tom de aviso do node "Triagem IA" (triagem que deixou de estar publicada).
  const warning = (text) => (
    <div role="alert" style={{ fontSize: 11, lineHeight: 1.5, color: isDark ? "#fbbf24" : "#b45309" }}>
      {text}
    </div>
  );
  if (!chosen) {
    if (loading) return null;
    // Conexão trocada no "Status da OS" (ou template apagado na Meta): sem o template na lista, o envio falharia.
    return warning(
      `O template "${nodeData.templateName}" não está entre os aprovados da conexão do "Status da OS". Escolha outro.`
    );
  }
  // Template escolhido antes de ligar ao "Status da OS" (no disparo em massa, tudo serve).
  const problem = orderTemplateProblem(chosen);
  if (problem) return warning(`O template "${chosen.name}" ${problem} e não sai sozinho para cada OS. Escolha outro.`);
  const value = { name: chosen.name, language: chosen.language, variables: nodeData.templateVariables || {} };
  return (
    <TemplateFields
      value={value}
      chosen={chosen}
      sources={ORDER_TEMPLATE_SOURCES}
      onChange={(next) => updateNodeData("templateVariables", next.variables)}
    />
  );
};

export default OrderTemplateVariables;
